import React, { useEffect, useState } from 'react';
import { getNameClient } from '../../helpers/nameClient';
import { Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import './syncconfig.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import Filters from '../../components/Common/Filters/filters';
import { getDynamicAttrUpdated } from '../../helpers/tools_helper';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getIdFromObject } from '../../helpers/tasks_helper';
import { addSyncConfiguration, deleteSyncConfiguration, getClients, getSyncConfiguration, updateSyncConfiguration } from '../../store/actions';
import Swal from 'sweetalert2';
import IForm from './SyncConfigForm';
import { ISwitch } from '../../components/Common/iComponents/iSwitch/iSwitch';
import Operations from '../../constants/operations';
import usePageTitle from '../../common/hooks/usePageTitle';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';

export const SyncConfigList = (props: any) => {
    const dispatch = useDispatch();
    const { listData, CountItems, filterItems, loading, error, errorCount } = useSelector((state: any) => state.SyncConfiguration);

    const PageTitleSyncC = usePageTitle(props.location.pathname);

    const { clients } = useSelector((state: any) => state.clients);

    const [pagination, setPagination] = useState<{
        sizePerPage: number;
        page: number;
    }>({
        sizePerPage: 50,
        page: 1,
    });
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [title, setTitle] = useState('');

    const [filters, setFilters] = useState<{
        from?: string;
        to?: string;
        dynamicFilter?: string;
        order?: string
    }>({
        dynamicFilter: '',
        order: "{ 'id': 'DESC' }"
    });
    const groupName = 'SyncConfigList';

    const onChangeBooleanHandler = (args: boolean, config: any, field: string) => {
        const newConfig = { ...config };
        newConfig[field] = args;
        dispatch(updateSyncConfiguration(newConfig));
        dispatch(getSyncConfiguration({ pagination, filters }));
    };
    const columns = [
        {
            text: 'Date',
            dataField: 'createdAt',
            visibleInTable: true,
        },
        {
            text: 'Client Id',
            dataField: 'clientId',
            visibleInTable: true,
            formatter: (cellContent: any, config: any) => {
                const client = clients.find((c: any) => `${c.id}` === config.clientId);

                return `${client?.id} - ${client?.name}`;
            },
        },
        {
            text: 'Operation',
            dataField: 'OperationType',
            visibleInTable: true,
            formatter: (cellContent: any, config: any) => {
                const operation = Operations.find((op) => op.OperationType === cellContent);

                return `${operation?.OperationType} - ${operation?.OperationName}`;
            },
        },
        {
            text: 'Workflow Enabled',
            dataField: 'WorkflowEnabled',
            visibleInTable: true,
            formatter: (cellContent: any, config: any) => {
                return (
                    <ISwitch
                        checked={config.WorkflowEnabled}
                        onChangeBooleanHandler={(args) => onChangeBooleanHandler(args, config, 'WorkflowEnabled')}
                    />
                );
            },
        },
        {
            text: 'Sync Enabled',
            dataField: 'SyncEnabled',
            visibleInTable: true,
            formatter: (cellContent: any, config: any) => {
                return (
                    <ISwitch checked={config.SyncEnabled} onChangeBooleanHandler={(args) => onChangeBooleanHandler(args, config, 'SyncEnabled')} />
                );
            },
        },
    ];


    useEffect(() => {
        dispatch(getClients({}));
    }, [dispatch]);

    useEffect(() => {
        dispatch(getSyncConfiguration({ pagination, filters }));
    }, [dispatch, filters, pagination]);


    useEffect(() => {
        if (error) {
            Swal.fire({
                title: 'There was an Error!',
                icon: 'error',
                text: error,
            });
        }
    }, [error, errorCount]);

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleActionOnSearch = (data: any) => {
        if (data.clientId) {
            data.clientId.forEach((c: any) => {
                const id = getIdFromObject(c);
                c.value = id;
            });
        }
        const filterString = getDynamicAttrUpdated(data);
        setFilters((prevFilters) => ({
            ...prevFilters,
            dynamicFilter: filterString,
            from: data.from,
            to: data.to,
        }));
    };

    const handleCreateSyncConfig = (data: any) => {
        setpopUpState(!popUpState);
        dispatch(addSyncConfiguration(data));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
        dispatch(getSyncConfiguration({ pagination, filters }));
    };

    const handleUpdateSyncConfig = (data: any) => {
        setpopUpState(!popUpState);
        dispatch(updateSyncConfiguration(data));
        dispatch(getSyncConfiguration({ pagination, filters }));
    };

    const handleDeleteSyncConfig = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(deleteSyncConfiguration(id));
        dispatch(getSyncConfiguration({ pagination, filters }));
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };
    const handleActionOnRowClick = (row: any) => {
        setTitle(`${row.clientId} - ${row.OperationType}`);
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };

    const handleTableSort = (type :any, { sortField, sortOrder }:any) => {
        setFilters( {...filters,
            order: `{'${sortField ?? 'id'}' : '${sortOrder.toUpperCase()}'}` 
        })
    }

    const handleCancel = () => {
        setpopUpState(!popUpState);
    };

    const AddButton = () => {
        return (
            <div className="d-flex justify-content-end pb-3">
                <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                    + Add
                </button>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>{PageTitleSyncC.replace(/-/g, ' ')} | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <div className="container-sm">
                        <Iloading  loading={loading}/>
                    </div>
                    <Row>
                        <AddButton />
                        <Filters onSearchClicked={handleActionOnSearch} filterItems={filterItems} hideDates />
                    </Row>
                    {/* La request de clients responde después que la de synconfig */}
                    {/* Se debe renderizar cuando hayan clients en el array, sino, se colocan undefined */}
                    {clients.length ? (
                        <Row>
                            <Row>
                                <ITable
                                    remote={true}
                                    CountItems={CountItems}
                                    handlerPaginationState={handlePaginationChange}
                                    data={listData}
                                    fields={columns}
                                    tableColumns={columns}
                                    headerColorT="bg-primary text-white"
                                    actionOnRowClick={handleActionOnRowClick}
                                    handlePopUpState={onPopUpState}
                                    groupName={groupName}
                                    handleTableSort={handleTableSort}
                                />
                            </Row>
                        </Row>
                    ) : (
                        <></>
                    )}
                </Container>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate="Sync Configuration"
                icon="settings"
                colorHeaderPop={'#101340'}
            >
                <IForm
                    selectedRow={selectedRow}
                    onCreateConfig={handleCreateSyncConfig}
                    onUpdateConfig={handleUpdateSyncConfig}
                    onDeleteConfig={handleDeleteSyncConfig}
                    onCancel={handleCancel}
                    filters={filters}
                />
            </IPopUp>
        </React.Fragment>
    );
};
